import { routeTo } from '../'

export const getBySlug = (byIdObject, slug) => {
  return Object.values(byIdObject).find(item => item.slug === slug)
}

export const getBySlugFromIdsArray = (idsArray, byIdObject, slug) => {
  const foundId = idsArray.find(id => byIdObject[id].slug === slug)

  return byIdObject[foundId]
}

export const getById = (byIdObject, id) => {
  return byIdObject[id]
}

export const getNextItem = (idsArray, byIdObject, id) => {
  const index = idsArray.indexOf(id)
  const nextIndex = index + 1
  const nextItemId = idsArray[nextIndex]

  return nextItemId ? byIdObject[nextItemId] : null
}

export const getPrevItem = (idsArray, byIdObject, id) => {
  const index = idsArray.indexOf(id)
  const nextIndex = index - 1
  const nextItemId = idsArray[nextIndex]

  return nextItemId ? byIdObject[nextItemId] : null
}

export const prevNavTo = (state, current, routes) => {
  const types = {
    chapter: state.chapters.chapters.byId,
    page: state.pages.byId,
  }

  const prev = getPrevItem(state.navigation.allIds, state.navigation.byId, current.id)
  if(!prev) return routeTo(routes, 'home')

  if(prev.type === 'quiz') return routeTo(routes, 'endtest')

  return prev && types[prev.type][prev[`${prev.type}Id`]]
    ? routeTo(routes, prev.type, { [prev.type]: types[prev.type][prev[`${prev.type}Id`]].slug })
    : routeTo(routes, 'home')
}

export const nextNavTo = (state, current, routes) => {
  const types = {
    chapter: state.chapters.chapters.byId,
    page: state.pages.byId,
  }

  const next = getNextItem(state.navigation.allIds, state.navigation.byId, current.id)
  if(!next) return routeTo(routes, 'home')

  if(next.type === 'quiz') return routeTo(routes, 'endtest')

  return next && types[next.type][next[`${next.type}Id`]]
    ? routeTo(routes, next.type, { [next.type]: types[next.type][next[`${next.type}Id`]].slug })
    : routeTo(routes, 'home')
}
